import { render, staticRenderFns } from "./RecursosDeGlosa.vue?vue&type=template&id=735baa5b"
import script from "./RecursosDeGlosa.vue?vue&type=script&lang=js"
export * from "./RecursosDeGlosa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports